import { AxiosResponse, isAxiosError } from 'axios';
import axios from 'utils/axios';
import { ActiveFieldsProps, UserMulticatalogResponse } from './auth.types';
import { ApiResponse } from 'types';

export const getUserMulticatalogService = async ({
    user
}: {
    user: string | null;
}): Promise<AxiosResponse<ApiResponse<UserMulticatalogResponse>>> => {
    try {
        const response = await axios.get(`/loolu/api/profile/user-multicatalog`, {
            params: { user }
        });

        return response;
    } catch (err: any) {
        if (isAxiosError(err)) {
            console.error('Axios error:', 'status:', err.response?.status, 'message:', err.message);
        } else {
            console.error('Unexpected error in getUserMulticatalogService:', err);
        }
        throw err;
    }
};

export const getActiveFieldsService = async ({
    idMerchant,
    idProvider
}: {
    idMerchant: number;
    idProvider: number;
}): Promise<ActiveFieldsProps> => {
    try {
        const response = await axios.get(`/loolu/api/product/activeFields`, {
            params: {
                idMerchant,
                idProvider
            }
        });

        return response.data.response;
    } catch (err: any) {
        if (isAxiosError(err)) {
            console.error('Axios error:', 'status:', err.response?.status, 'message:', err.message);
        } else {
            console.error('Unexpected error in getUserMulticatalogService:', err);
        }
        throw err;
    }
};

export const getTenantIdService = async ({ tenant }: { tenant: string }): Promise<string | null> => {
    try {
        const response = await axios.get<{
            id: string;
        }>(`/loolu/api/auth/tenants/${tenant}`);
        const id = response.data.id || null;
        return id;
    } catch (err) {
        if (isAxiosError(err)) {
            console.error('Axios error:', 'status:', err.response?.status, 'message:', err.message);
        } else {
            console.error('Unexpected error in getTenantIdService:', err);
        }
        throw err;
    }
};

export const getTermAndProviderService = async (): Promise<
    AxiosResponse<
        ApiResponse<{
            isProvider: boolean;
            termsAndConditions: boolean;
        }>
    >
> => {
    try {
        const response = await axios.get(`/loolu/api/termsandconditions/accepted`, {});

        return response;
    } catch (err) {
        if (isAxiosError(err)) {
            console.error('Axios error:', 'status:', err.response?.status, 'message:', err.message);
        } else {
            console.error('Unexpected error in getTenantIdService:', err);
        }
        throw err;
    }
};
